export const SPACE_SETTINGS_DETAILS_ANALYTICS_SOURCE = 'spaceSettingsDetails';
export const SPACE_SETTINGS_DETAILS_ANALYTICS_FF = 'confluence-fe-space-settings-space-details';
export const NOT_APPLICABLE = 'N/A';
